import http from '../common/http';
import env from '../envConfig';
import { getHeader } from '../auth/authManager';
import { responseHandler } from '../common/responseHandler';

export enum AcaoIndicativoNascimento {
  NAO_DESEJA_INCLUIR = 3,
  INCLUSAO_OUTRO_MOMENTO = 4,
  CRIANCA_EH_PCD = 5,
}

export interface AcaoIndicativoNascimentoDTO {
  cpfUsuarioSolicitante: string;
  cpfIndicativoNascimento: string;
  codigoAcao: AcaoIndicativoNascimento;
}

export interface IntegranteIndicativoNascimentoDTO {
  cpf: string;
  nome: string;
  dataNascimento: string;
  sexo: string;
  filiacao1: string;
  filiacao2: string;
  relacaoParentesco: number;
  corRaca: number;
  naoSabeNomeCompletoPai: boolean;
  matricula: string;
  numeroCartorioCertidao: string;
  nomeCartorioPessoa: string;
  nuIbgeMunicipioCertidao: number;
  dataLavratura: string;
}

export interface FamiliaIndicativoNascimentoDTO {
  nuFamiliar: string;
  integrantesIndicativoNascimento: IntegranteIndicativoNascimentoDTO[];
}

export const obterIntegrantesIndicativoNascimento = async (numeroFamiliar: string): Promise<FamiliaIndicativoNascimentoDTO> => {
  const url = env.urlApi + `/transacional-api/v1/indicativo-nascimento/${numeroFamiliar}/integrantes`;
  const headers = getHeader();
  const response = await http.get(url, { headers });
  return responseHandler(response);
};

export const incluirIntegranteIndicativoNascimento = async (numeroFamiliar: string, dto: IntegranteIndicativoNascimentoDTO): Promise<{ mensagem: string }> => {
  const url = env.urlApi + `/transacional-api/v1/indicativo-nascimento/${numeroFamiliar}/integrantes`;
  const headers = getHeader();
  const response = await http.post(url, dto, { headers }).catch((err: any) => err);
  return responseHandler(response);
};

export const determinarAcaoIndicativoNascimento = async (
  numeroFamiliar: string,
  dto: AcaoIndicativoNascimentoDTO
): Promise<void> => {
  const url = env.urlApi + `/transacional-api/v1/indicativo-nascimento/${numeroFamiliar}/acao-indicativo`;
  const headers = getHeader();
  const response = await http.put(url, dto, { headers });
  return responseHandler(response);
};
